import { render } from "./DynamicTabPage.vue?vue&type=template&id=060ef910&scoped=true&ts=true"
import script from "./DynamicTabPage.vue?vue&type=script&lang=ts"
export * from "./DynamicTabPage.vue?vue&type=script&lang=ts"

import "./DynamicTabPage.vue?vue&type=style&index=0&id=060ef910&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060ef910"]])

export default __exports__